import React, { useEffect, useState } from "react";
import "./summary.css";
import Arbre from "../../assets/images/landing/arbre.png";
import { Link } from "react-router-dom";
import { Header } from "../../components/layout";
import { useWindowSize } from "../../hooks/useWindowSize";

const defaultData = [
  {
    title: "Les ateliers",
    link: "/ateliers",
  },
  {
    title: "Nos partenaires",
    link: "/partenaires",
  },
  {
    title: "Infos pratiques et Contact",
    link: "/contact",
  },
  {
    title: "Le concept",
    link: "/le-concept",
  },
  {
    title: "Le Lieu",
    link: "/le-lieu",
  },
  {
    title: "Nous connaître",
    link: "/nous-connaitre",
  },
];

function Summary() {
  const [data, setData] = useState(defaultData);

  const width = useWindowSize().width;

  useEffect(() => {
    if (width < 400) {
      setData([
        defaultData[3],
        defaultData[4],
        defaultData[5],
        defaultData[0],
        defaultData[1],
        defaultData[2],
      ]);
    } else {
      setData(defaultData);
    }
  }, [width]);

  return (
    <section className="Summary" id="summary">
      <div className="inner">
        <Header title="Sommaire" />
        <div className="tree-container">
          <img src={Arbre} alt="Arbre" className="tree-image" />
          <div>
            {data.map((item, index) => (
              <Link to={item.link} className={`link link-${index + 1}`}>
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Summary;
